import React, { Component } from "react";
import { useNavigation } from "../../utilities/NavigationContext";

class CreditTopupCancel extends Component {
  goToPricing = () => {
    this.props.navigate("/pricing");
  };

  goToPlanning = () => {
    this.props.navigate("/planning"); // same as success page
  };

  render() {
    return (
      <div className="p-5 text-center bg-slate-100 text-md rounded shadow m-20">
        <h1 className="text-xl font-bold my-4">Top-up Cancelled ❌</h1>

        <p>Your credit purchase was cancelled or not completed.</p>

        <div className="mt-20">
          <button
            onClick={this.goToPricing}
            className="bg-sky-700 hover:bg-sky-800 text-white rounded shadow p-4 mr-4"
          >
            Retry Top-up
          </button>

          <button
            onClick={this.goToPlanning}
            className="bg-sky-700 hover:bg-sky-800 text-white rounded shadow p-4"
          >
            Go to Planning
          </button>
        </div>
      </div>
    );
  }
}

const CreditTopupCancelWithNavigation = (props) => {
  const navigate = useNavigation();
  return <CreditTopupCancel {...props} navigate={navigate} />;
};

export default CreditTopupCancelWithNavigation;
